export const FETCH_ALL_PROVIDERS = 'FETCH_ALL_PROVIDERS';
export const FETCH_PROVIDER = 'FETCH_PROVIDER';
export const CREATE_PROVIDER = 'CREATE_PROVIDER';
export const UPDATE_PROVIDER= 'UPDATE_PROVIDER';
export const REMOVE_PROVIDER = 'REMOVE_PROVIDER';